export type RateGaugeSize = "large" | "default" | "xs";

export const RateGaugeGeometry: Record<
    RateGaugeSize,
    { box: number; thickness: number }
> = {
    large: { box: 230, thickness: 18 },
    default: { box: 170, thickness: 12 },
    xs: { box: 27, thickness: 4 },
};
